// adding types for all objects so these are available for
// quick view wherever they are used

// Payment status
// 0 Not initiated
// 1 COD
// 2 is online not settled
// 3 failed online
// 4 payout initiated
// 5 online settled
// 6 refund initiated
// 7 refund successful

export const PAYMENT_STATUS = {
  NOT_INITIATED: 0,
  COD: 1,
  IS_ONLINE_NOT_SETTLED: 2,
  FAILED_ONLINE: 3,
  PAYOUT_INITIATED: 4,
  ONLINE_SETTLED: 5,
  REFUND_INITIATED: 6,
  REFUND_SUCCESSFUL: 7,
} as const;

export const PAYMENT_MODE = {
  NONE: 0,
  PREPAID: 1,
  PAY_ON_DELIVERY: 2,
  CASH_ON_DELIVERY: 3,
} as const;

// ORDER STATUS
// 1 - Customer updated, new
// 2 - Merchant updated, bill sent
// 3 - Rejected, canceled
// 4 - Active
// 5 - Ready
// 6 - Out for Delivery
// 7 - Completed
// 8 - Cancelled
// 9 - seen by merchant, order seen
// 10 - Prepaid, unpaid (cart)

export const ORDER_STATUS = {
  CUSTOMER_UPDATED_NEW: 1,
  MERCHANT_UPDATED_BILL_SENT: 2,
  REJECTED: 3,
  ACTIVE: 4,
  READY: 5,
  OUT_FOR_DELIVERY: 6,
  COMPLETED: 7,
  CANCELLED: 8,
  ORDER_SEEN: 9,
  PREPAID: 10,
  CUSTOMER_CANCELLED: 12,
  COD_CONFIRMED: 13,
} as const;

// Order Type
// 1. Delivery
// 2. Pickup
// 3. Self Billed
// 4. Payment Link

export const ORDER_TYPE = {
  B2B: 0,
  DELIVERY: 1,
  PICKUP: 2,
  SELF_BILLED: 3,
  PAYMENT_LINK: 4,
  SERVICE: 5,
} as const;

export const PARTIAL_PAYMENT_ORDER_COMPLETION_STATUS_TYPES = {
  NONE: 0,
  PARENT_COMPLETE: 1,
  CHILD_COMPLETE: 2,
  BOTH_COMPLETE: 3,
} as const;

export const PREPAID_FLAG = {
  POSTPAID: 0,
  PREPAID: 1,
} as const;

export const ORDER_STATUS_COLOR_KEY = {
  STATUS_SUCCESS: "#46A414",
  STATUS_REJECTED: "red",
  STATUS_IN_PROGRESS: "orange",
} as const;

export const PARTNER_DELIVERY_FLAG = {
  SELF_DELIVER: 1,
  PARTNER_DELIVER: 2,
  SELF_AND_PARTNER_DELIVER: 3,
} as const;

export const ORDER_CUSTOMIZATION = {
  ORDER: 0,
  SERVICE: 1,
  SERVICE_WITH_ADDRESS: 2,
  B2B: 3,
} as const;

export const ITEM_STATUS = {
  ITEM_STATUS_ACTIVE: 1,
  ITEM_STATUS_INACTIVE: 2,
} as const;
